import { BlockScroll, Modal, ModalClose, ModalContent } from "@birdwatch/ui";
import { cn } from "cn";
import { BwCloseLine } from "@/components/ui/icons/icons.generated";

const MEMBERSHIP_AGREEMENT_URL =
  "https://birdwatch.notion.site/ebd//239c60c90c46808cbf47d52da2c6f42f";

export function MembershipAgreementModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Modal open={open} onOpenChange={onClose}>
      <ModalContent
        dialogProps={{ showCloseButton: false }}
        drawerProps={{ showCloseButton: false, showHandleButton: false }}
        className={cn(
          /* sorted */
          "flex flex-col",
          "h-full gap-0 p-0",
          "border border-border-dark-low",
          "sm:max-h-[calc(100%-4rem)] sm:max-w-5xl",
        )}
      >
        <ModalClose className="absolute top-3 right-4 left-3 inline-flex size-6 cursor-pointer items-center justify-center rounded-full bg-bg-dark-min ring-offset-background transition-opacity hover:bg-bg-dark-low focus:bg-bg-dark-min focus:outline-hidden focus:ring-0 disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-5">
          <BwCloseLine size={16} className="text-text-dark-max" />
        </ModalClose>
        <BlockScroll className="min-h-0 flex-1">
          <div className="h-full min-h-[60dvh] p-4 pt-1">
            <iframe
              src={MEMBERSHIP_AGREEMENT_URL}
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
              className="h-full min-h-[50dvh] overflow-y-auto"
            />
          </div>
        </BlockScroll>
      </ModalContent>
    </Modal>
  );
}
